import React, { ReactNode } from 'react';

interface ContentCardProps {
  title: string;
  titleClassName?: string;
  children: ReactNode;
}

const ContentCard: React.FC<ContentCardProps> = ({ 
  title,
  titleClassName = "text-primary-dark",
  children 
}) => (
  <div className="bg-white rounded-lg p-8 shadow-md">
    <h3 className={`text-xl font-bold mb-4 ${titleClassName}`}>{title}</h3>
    <div className="prose prose-sm sm:prose lg:prose-lg max-w-none text-gray-600">
      {children}
    </div>
  </div>
);

export default ContentCard; 